import { render } from "./DashboardOrdenesEntrada.vue?vue&type=template&id=388916ac&scoped=true"
import script from "./DashboardOrdenesEntrada.vue?vue&type=script&lang=js"
export * from "./DashboardOrdenesEntrada.vue?vue&type=script&lang=js"

import "./DashboardOrdenesEntrada.vue?vue&type=style&index=0&id=388916ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388916ac"]])

export default __exports__